import { mapGetters } from 'vuex';
import { isBizPlusContext } from '../common/utils';
import { plansof } from '@/utils/chain';
import { BASE_PLAN_SUB_TYPES, planTypes } from '@/common/constants';

export default {
  computed: {
    ...mapGetters(['plansofBizBundle', 'getSelectedPlans', 'migratePlanState']),
    isAutoDisabledCycleDesc() {
      return this.$t('billing.zobizplus.subscription_cycle_same_as_other_plan', [this.$t('billing.planform.title.zoom_one_biz'), this.$t('billing.planform.title.zoom_one_biz_plus')]);
    },
    selectedBizPlusCycle() {
      const { selectedBizPlusPlan, boughtBizPlusPlan } = this.plansofBizBundle;
      if (this.migratePlanState.is.downgrade) {
        return boughtBizPlusPlan?.[0]?.billing_cycle;
      }
      return selectedBizPlusPlan?.[0]?.billing_cycle;
    },
  },
  watch: {
    selectedBizPlusCycle: {
      immediate: true,
      async handler() {
        if (!isBizPlusContext) return;
        if (this.migratePlanState.is.downgrade) return;
        await this.$nextTick();
        const { selectedBizPlan } = this.plansofBizBundle;
        const oldPlan = selectedBizPlan?.[0];
        if (!oldPlan || selectedBizPlan.length > 1) return
        const meetingPlans = plansof(this.planMapFlat)
          .type(planTypes.ZOOM_MEETING)
          .category(BASE_PLAN_SUB_TYPES.BIZ)
          .get();
        const planCode = meetingPlans.filter((p) => p.billing_cycle === this.selectedBizPlusCycle)?.[0]?.plan_code;
        const cartInfo = { selected_number: oldPlan.cartInfo.selected_number };
        if (oldPlan?.plan_code === planCode || !planCode) return;
        await this.switchBillingCycleAction([
          oldPlan?.plan_code,
          {
            plan_code: planCode,
            cartInfo,
          },
        ]);
      },
    },
  },
  methods: {
    autoDisabledCycle(billingCycle) {
      if (this.migratePlanState.is.downgrade) return false;
      if (!isBizPlusContext) return false;
      if (this.selectedBizPlusCycle && billingCycle !== this.selectedBizPlusCycle) {
        return true;
      }
      return false;
    }
  }
};
